import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "col-12 text-left" }, [
  /*#__PURE__*/_createVNode("h6", { class: "font-weight-bold" }, "Options")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabMenu = _resolveComponent("TabMenu")

  return (_ctx.load == true)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_TabMenu, { model: _ctx.options }, null, 8, ["model"])
        ])
      ]))
    : _createCommentVNode("", true)
}